import { Box, TextV2 } from '@withjoy/joykit';
import { styled } from '@withjoy/joykit/theme';

export const StyledRoot = styled(Box)`
  flex-shrink: 0;
  @media print {
    display: none;
  }
`;

export const StyledLeftSection = styled(Box)``;

export const StyledRightSection = styled(Box)``;

export const StyledTitle = styled(TextV2)``;
